import { render, staticRenderFns } from "./aiDesign.vue?vue&type=template&id=780ef8f8&scoped=true"
import script from "./aiDesign.vue?vue&type=script&lang=js"
export * from "./aiDesign.vue?vue&type=script&lang=js"
import style0 from "./aiDesign.vue?vue&type=style&index=0&id=780ef8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ef8f8",
  null
  
)

export default component.exports